import { Map } from "immutable";
import { ACTION_SAVE_ACTION_SUCCESSFUL } from "UserAuthorized/actionTypes";

const InitialState = {
  magicLink: Map()
};

const actionReducer = (state = Map(InitialState), action) => {
  switch (action.type) {
    case ACTION_SAVE_ACTION_SUCCESSFUL:
      return state.set("magicLink", Map(action.payload));
    default:
      return state;
  }
};

export default actionReducer;
